import { Injectable } from '@angular/core';
import { FormGroup, ValidatorFn } from '@angular/forms';

@Injectable()
export class FormService {

  constructor() { }

  /**
   * Sets field visibility
   * @param form 
   * @param fields 
   * @param action 
   */
  setFieldVisibility(form: FormGroup, fields: string[], action: 'enable' | 'disable') {
    if (fields?.length) {
      fields?.forEach((field) => {
        form?.get(field)?.[action]();
      });
    }
  }

  /**
   * Sets visibility
   * @param form 
   * @param action 
   */
  setVisibility(form: FormGroup, action: 'enable' | 'disable') {    
    form?.[action]();
  }

  /**
   * Sets field dirty or pristine
   * @param form 
   * @param formControlName 
   * @param status 
   */
  setFieldDirtyOrPristine(form: FormGroup, formControlName: string, status: boolean) {
    if (form && formControlName) {
      status ? form?.get(formControlName)?.markAsDirty() : form?.get(formControlName)?.markAsPristine();
    }
  }

  /**
   * Sets fields dirty or pristine
   * @param form 
   * @param fields 
   * @param status 
   */
  setFieldsDirtyOrPristine(form: FormGroup, fields: string[], status: boolean) {
    if (form && fields?.length) {
      fields?.forEach((field) => {
        status ? form?.get(field)?.markAsDirty() : form?.get(field)?.markAsPristine();
      });
    }
  }

  /**
   * Sets all field dirty or pristine
   * @param form 
   * @param [isDirty] 
   */
  setAllFieldDirtyOrPristine(form: FormGroup, isDirty: boolean = false) {
    Object.values(form?.controls)?.forEach((control: any) => {
      isDirty ? control?.markAsDirty() : (control?.value ? control?.markAsDirty() : control?.markAsPristine());
      if ((control as FormGroup)?.controls) {
        this.setAllFieldDirtyOrPristine(control as FormGroup, isDirty);
      }
    });
  }

  /**
   * Sets form values
   * @param form 
   * @param fieldValueGroup 
   */
  setFormValues(form: FormGroup, fieldValueGroup: {[s: string]: any}) {
    form.patchValue(fieldValueGroup);
    this.setFieldsDirtyOrPristine(form, Object.keys(fieldValueGroup), true);
  }

  /**
   * Resets form
   * @param form 
   */
  resetForm(form: FormGroup) {    
    form?.reset();
  }

  /**
   * Manages validator by value
   * @param form 
   * @param formControlName 
   * @param valueStatus 
   * @param validators 
   */
  manageValidatorByValue(form: FormGroup, formControlName: string, valueStatus: boolean, validators: ValidatorFn | ValidatorFn[]) {
    valueStatus
      ? form?.get(formControlName)?.clearValidators()
      : form?.get(formControlName)?.setValidators(validators);
    form?.get(formControlName)?.updateValueAndValidity();
  }

  /**
   * Sets all as touched
   * @param form 
   */
  setAllAsTouched(form: FormGroup) {
    form.markAllAsTouched();
  }

  /**
   * Updates form value and validity
   * @param form 
   */
  updateFormValueAndValidity(form: FormGroup) {
    form?.updateValueAndValidity();
  }
}
